import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="qred-fading-circle">
      <div className="qred-circle1 qred-circle" />
      <div className="qred-circle2 qred-circle" />
      <div className="qred-circle3 qred-circle" />
      <div className="qred-circle4 qred-circle" />
      <div className="qred-circle5 qred-circle" />
      <div className="qred-circle6 qred-circle" />
      <div className="qred-circle7 qred-circle" />
      <div className="qred-circle8 qred-circle" />
      <div className="qred-circle9 qred-circle" />
      <div className="qred-circle10 qred-circle" />
      <div className="qred-circle11 qred-circle" />
      <div className="qred-circle12 qred-circle" />
    </div>
  );
};

export default LoadingSpinner;
